// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/root/QICK_DASHBOARD_V4_FRONTEND/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '/root/QICK_DASHBOARD_V4_FRONTEND/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import CalendarOutlined from '/root/QICK_DASHBOARD_V4_FRONTEND/node_modules/@ant-design/icons/es/icons/CalendarOutlined';
import TeamOutlined from '/root/QICK_DASHBOARD_V4_FRONTEND/node_modules/@ant-design/icons/es/icons/TeamOutlined';
import TableOutlined from '/root/QICK_DASHBOARD_V4_FRONTEND/node_modules/@ant-design/icons/es/icons/TableOutlined';
import CodeOutlined from '/root/QICK_DASHBOARD_V4_FRONTEND/node_modules/@ant-design/icons/es/icons/CodeOutlined';
export default { SmileOutlined, CrownOutlined, CalendarOutlined, TeamOutlined, TableOutlined, CodeOutlined };
